import React from "react";

import { THEMES } from "../constants";

const initialState = {
  theme: THEMES.DEFAULT,
  setTheme: (theme) => {},
};
const ThemeContext = React.createContext(initialState);

function ThemeProvider({ children }) {
  const initialState = () => {
    try {
      if (localStorage.getItem("theme")) {
        localStorage.removeItem("theme");
      }
      const storedTheme = sessionStorage.getItem("theme");
      return storedTheme ? JSON.parse(storedTheme) : THEMES.DEFAULT;
    } catch (error) {
      return THEMES.DEFAULT;
    }
  };

  const [theme, _setTheme] = React.useState(initialState());

  const setTheme = (theme) => {
    try {
      sessionStorage.setItem("theme", JSON.stringify(theme));
    } catch (e) {}
    _setTheme(theme);
  };

  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
}

export { ThemeProvider, ThemeContext };
